import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";

import PageBanner from "../Components/PageBanner";
import ServiceCard from "../Components/ServiceCard";
// import NewsCard from "../Components/NewsCard";
import {
  servicesData as initialServicesData,
  newsData as initialNewsData,
} from "../Constants/Data";

export default function Services() {
  const [servicesData, setServicesData] = useState([]);

  useEffect(() => {
    setServicesData(initialServicesData);
  }, []);

  const [newsData, setNewsData] = useState([]);

  useEffect(() => {
    setNewsData(initialNewsData);
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsPerRow, setCardsPerRow] = useState(3);

  const visibleItems = newsData.slice(currentIndex, currentIndex + cardsPerRow);
  const handleNext = () => {
    if (currentIndex + cardsPerRow < newsData.length) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevIndex) => prevIndex - 1);
    }
  };
  return (
    <>
      <Helmet>
        {/* Basic SEO */}
        <title>Services | Urban View Real Estate PVT LTD</title>
        <meta
          name="description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta
          name="keywords"
          content="Affordable Homes for Sale in South Australia, Affordable Homes for Sale in Melbourne, Affordable Homes for Sale in Queensland, Development Sites for Sale in Sydney, Cheap Rent a Home in Penrith, House Buying in Western Australia, Cheap Duplex Home in Tamworth, Affordable duplex Home in Armidale, Houses for Rental in St Marys, Investement Property in Queensland, Best Investment Property Sale in Brisbane, Best Investment Property Sale in Rouse Hill, Box Hill, Marsden Park, Vineyard, Investment Property Buy in Austral, Investment Property Buy in Tallawong, Investment Property Buy in Oran Park, Investment Property Buy in Leppington"
        />

        <meta name="author" content="Urban View Real Estate PVT LTD" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://urbanviewre.com/services" />

        {/* Open Graph */}
        <meta property="og:title" content="Urban View Real Estate PVT LTD" />
        <meta
          property="og:description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta property="og:site_name" content="Urban View Real Estate" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://urbanviewre.com" />
        <meta
          property="og:image"
          content="https://urbanviewre.com/assets/logo-2-CGgGTWZk.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Urban View Real Estate PVT LTD" />
        <meta
          name="twitter:description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta
          name="twitter:image"
          content="https://urbanviewre.com/assets/logo-2-CGgGTWZk.png"
        />
        <meta name="twitter:site" content="@urbanviewre" />
        <meta name="twitter:creator" content="@urbanviewre" />

        {/* Facebook  */}
        <meta
          property="fb:admins"
          content="https://www.facebook.com/profile.php?id=61559035348971"
        />

        {/* Instagram */}
        <meta name="instagram:title" content="Urban View Real Estate PVT LTD" />
        <meta
          name="instagram:description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta name="instagram:site" content="@urbanviewrealestate" />
      </Helmet>

      <PageBanner
        title="Services"
        breadcrumbs={[
          { label: "Home", href: "/", icon: "bi-house-door-fill" },
          { label: "Services", active: true },
        ]}
      />

      <section className="bg-light py-5 mb-5 text-center">
        <div className="container">
          <h6 className="badge text-primary rounded-4 fw-bold px-3 fs-6">
            Our Services
          </h6>
          <h2 className="fw-bold brand py-3">Our Main Focus</h2>
          <div className="row mt-4 d-flex justify-content-center justify-content-lg-start">
            {servicesData.map((service) => (
              <ServiceCard key={service.id} {...service} />
            ))}
          </div>
        </div>
      </section>

      {/* <section className="slider py-5 mb-5 text-center">
        <div className="container">
          <h6 className="badge text-primary rounded-4 fw-bold px-3 fs-6">
            News & Blogs
          </h6>
          <h2 className="fw-bold brand py-3">Leatest News Feeds</h2>
          <div className="mt-5 position-relative">
            <div className="row">
              {visibleItems.map((news) => (
                <div className="col-md-4 mb-4" key={news.id}>
                  <NewsCard
                    image={news.image}
                    title={news.title}
                    author={news.author}
                    category={news.category}
                    date={news.date}
                    link={news.link}
                  />
                </div>
              ))}
            </div>

            <button
              className="carousel-control-prev rounded-circle border position-absolute"
              type="button"
              style={{
                top: "50%",
                zIndex: "2",
                width: "50px",
                height: "50px",
              }}
              onClick={handlePrev}
            >
              <span aria-hidden="true">
                <i className="bi bi-arrow-left text-dark fs-4"></i>
              </span>
              <span className="visually-hidden">Previous</span>
            </button>

            <button
              className="carousel-control-next rounded-circle border position-absolute"
              type="button"
              style={{
                top: "50%",
                zIndex: "2",
                width: "50px",
                height: "50px",
              }}
              onClick={handleNext}
            >
              <span aria-hidden="true">
                <i className="bi bi-arrow-right text-dark fs-4"></i>
              </span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </section> */}
    </>
  );
}
